import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { isAuthenticated, getProfile, logout } from 'services/auth';

export default function PrivateRoute({ path, component: Component, accessId }) {
  const [user, setUser] = useState({});

  useEffect(() => {
    (async () => {
      const isAuth = await isAuthenticated();
      const profile = await getProfile();
      const userInfo = JSON.parse(profile || '{}');

      if (isAuth) {
        setUser(userInfo);
      } else {
        await logout();
      }
    })();
  }, []);

  const { acessos } = user;
  return (
    !!Object.keys(user).length && (
      <>
        {acessos.some(id => accessId.includes(id)) ? (
          <Route
            path={path}
            render={props => (
              <Component
                {...props}
                user={user}
                hasAccess={acessos.some(id => accessId.includes(id))}
              />
            )}
          />
        ) : (
          <Redirect to={{ pathname: '/not-allowed' }} />
        )}
      </>
    )
  );
}

PrivateRoute.propTypes = {
  path: PropTypes.string.isRequired,
  accessId: PropTypes.number.isRequired,
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};
